import assets from "./regimeArtwork.assets.json";

/** Reviewed catalogue IDs identify the issuer; no guessed names or runtime scraping. */
export const REGIME_ARTWORK: Readonly<Record<string, readonly (keyof typeof assets)[]>> = {
  "adgm-aml": ["adgm"],
  "aifmd": ["eu"],
  "amlgas": ["ccab"],
  "au-amlctf": ["austrac"],
  "bermuda-aml": ["bma"],
  "bvi-aml": ["bvifsc"],
  "ca-ccpa": ["cppa"],
  "cayman-amlr": ["cima"],
  "cbi-opres-outsourcing": ["cbi"],
  "ch-amla": ["finma"],
  "cima-cg-rule": ["cima"],
  "cis-controls-v8": ["cis"],
  "csrd-esrs": ["eu"],
  "cssf-20-750": ["cssf"],
  "cssf-22-806": ["cssf"],
  "dac6-mdr": ["eu", "oecd"],
  "difc-dfsa-aml": ["dfsa"],
  "difc-dpl-2020": ["difc"],
  "dol-fiduciary-erisa": ["us-dol"],
  "economic-substance": ["guernsey-registry", "jfsc", "iomfsa", "cima", "bvifsc"],
  "emir": ["eu"],
  "eu-ai-act": ["eu"],
  "eu-amld": ["eu"],
  "eu-amlr": ["eu"],
  "eu-dora": ["eu"],
  "eu-gdpr": ["eu"],
  "eu-nis2": ["eu"],
  "fatca": ["irs"],
  "fatf-40": ["fatf"],
  "fca-cobs": ["fca"],
  "fca-consumer-duty": ["fca"],
  "fca-icobs": ["fca"],
  "fca-smcr": ["fca", "boe"],
  "fca-sysc": ["fca"],
  "finra-rules": ["finra"],
  "frc-afgc": ["frc"],
  "frc-ethical-standard": ["frc"],
  "gfsc-aml": ["gfsc"],
  "gfsc-cg-code": ["gfsc"],
  "gfsc-cyber-rules": ["gfsc"],
  "gfsc-fiduciary-rules": ["gfsc"],
  "gfsc-insurance-rules": ["gfsc"],
  "gg-companies-law-ubo": ["guernsey-registry"],
  "gg-dpl-2017": ["odpa"],
  "gg-pension-rules": ["gfsc"],
  "gg-poi-law": ["gfsc"],
  "hk-amlo": ["sfc", "hkma"],
  "iais-icp": ["iais"],
  "idd": ["eu"],
  "ie-cja-2010": ["cbi"],
  "ie-iaf-sear": ["cbi"],
  "iesba-code": ["iesba"],
  "ifsca-aml-2022": ["ifsca"],
  "ifsca-fm-2025": ["ifsca"],
  "in-dpdp-2023": ["meity"],
  "in-pmla-2002": ["fiu-ind"],
  "iom-aml-code": ["iomfsa"],
  "iom-gdpr": ["iom-ic"],
  "iom-rulebook": ["iomfsa"],
  "iorp-2": ["eu"],
  "irdai-aml-2022": ["irdai"],
  "irdai-cyber-2026": ["irdai"],
  "irs-broker-reporting": ["irs"],
  "isa-220-revised": ["iaasb"],
  "isae-3000": ["iaasb"],
  "iso-22301": ["iso"],
  "iso-27001": ["iso"],
  "iso-27017-27018": ["iso"],
  "iso-27701": ["iso"],
  "iso-37001": ["iso"],
  "iso-37301": ["iso"],
  "iso-42001": ["iso"],
  "isqm-1": ["iaasb"],
  "isqm-2": ["iaasb"],
  "issb-s1-s2": ["ifrs"],
  "je-dpjl-2018": ["joic"],
  "jfsc-aml": ["jfsc"],
  "jfsc-fund-codes": ["jfsc"],
  "jfsc-tcb-code": ["jfsc"],
  "jmlsg": ["jmlsg"],
  "ky-dpa": ["ombudsman-ky"],
  "ky-funds-acts": ["cima"],
  "lloyds-principles": ["lloyds"],
  "lsag-aml": ["sra"],
  "lux-aml": ["cssf"],
  "mas-trm": ["mas"],
  "mica": ["eu"],
  "mifid-2": ["eu"],
  "mt-fiau": ["fiau"],
  "mu-fiamla": ["fsc-mauritius"],
  "nasaa-state-securities": ["nasaa"],
  "nist-csf-2": ["nist"],
  "nydfs-500": ["nydfs"],
  "oecd-crs": ["oecd"],
  "pcaob-qc-1000": ["pcaob"],
  "pci-dss": ["pci"],
  "pra-fundamental-rules": ["boe"],
  "rbi-cyber-tech-risk-2026": ["rbi"],
  "rbi-kyc-directions-2025": ["rbi"],
  "rbi-outsourcing-directions-2025": ["rbi"],
  "sebi-cscrf-2024": ["sebi"],
  "sebi-ia-2013": ["sebi"],
  "sebi-intermediaries-2008": ["sebi"],
  "sebi-lodr-2015": ["sebi"],
  "sebi-pit-2015": ["sebi"],
  "sec-advisers-act": ["sec"],
  "sec-advisers-act-conduct": ["sec"],
  "sec-bd-financial-responsibility": ["sec", "sipc"],
  "sec-reg-bi": ["sec"],
  "sec-reg-d-private-offerings": ["sec"],
  "sec-reg-s-id": ["sec"],
  "sec-reg-sp": ["sec"],
  "sec-trading-market-structure": ["sec", "finra"],
  "sfdr": ["eu"],
  "sg-mas-aml": ["mas"],
  "sg-pdpa": ["pdpc"],
  "soc1-isae3402": ["aicpa", "iaasb"],
  "soc2": ["aicpa"],
  "solvency-2": ["eu", "boe"],
  "sox-404": ["sec", "pcaob"],
  "sra-standards-regulations": ["sra"],
  "tcfd": ["fsb"],
  "tpr-general-code": ["tpr"],
  "uae-aml": ["uae"],
  "ucits": ["eu"],
  "uk-bribery-act": ["uk-government"],
  "uk-cfa-2017": ["uk-government"],
  "uk-cyber-essentials": ["iasme"],
  "uk-eccta-fraud": ["uk-government"],
  "uk-gdpr": ["ico"],
  "uk-mlr-2017": ["uk-government"],
  "uk-modern-slavery": ["uk-government"],
  "uk-opres": ["fca", "boe"],
  "uk-outsourcing": ["fca", "boe"],
  "uk-poca-2002": ["uk-parliament"],
  "uk-sanctions": ["uk-government"],
  "uk-sdr": ["fca"],
  "us-ai-financial-services": ["finra", "sec", "nist"],
  "us-bsa": ["fincen"],
  "us-cash-sweep-deposit-insurance": ["fdic", "finra"],
  "us-fcpa": ["us-doj", "sec"],
  "us-glba": ["ftc"],
  "us-margin-securities-lending": ["federal-reserve", "sec", "finra"],
  "us-ofac": ["us-treasury"],
  "wolfsberg": ["wolfsberg"],
};

export function regimeArtwork(regimeId: string) {
  const keys = Object.hasOwn(REGIME_ARTWORK, regimeId) ? REGIME_ARTWORK[regimeId] ?? [] : [];
  return keys.map(key => ({ key, ...assets[key] }));
}

/** Curated issuer colours keep card feedback instant, without canvas reads or image decoding. */
export function regimeCardColors(regimeId: string) {
  const marks = regimeArtwork(regimeId);
  return {
    '--regime-accent': marks[0]?.colors[0] ?? '#81909f',
    '--regime-accent-secondary': marks[1]?.colors[0] ?? marks[0]?.colors[1] ?? '#a3afb9',
  };
}
